<script lang="ts">
import listPanel from '@nuxtDatakodeUtils/components/i3p/panels/list-panel.vue'
import BasicFiltersOverride from '../common/list/BasicFiltersOverride.vue'

import Pagination from '../common/list/Pagination.vue'
import IntentionsListButtons from '~/components/I3pComponent/intentions/ListButtons.vue'
import FiltersTemplate from '~/components/I3pComponent/common/list/FiltersTemplate.vue'
import GeojsonUrl from '~/components/I3pComponent/common/list/GeojsonUrl.vue'
// import IntentionData = PildomModules.Voirie.Data.IntentionData

export default {
    name: 'IntentionListPanel',
    components: { GeojsonUrl, FiltersTemplate, IntentionsListButtons, Pagination, BasicFiltersOverride },
    extends: listPanel,
    data() {
        return {
            columns: [
                { dataKey: 'id' },
                { dataKey: 'status', transform: [this.toTranslate], template: [this.isChips] },
                { dataKey: 'commune.t' },
                { dataKey: 'organization.t' },
                { dataKey: 'name' },
                { dataKey: 'opportunity', transform: [this.hasOpportunityUrl] },
                { dataKey: 'due_status', transform: [this.toTranslate] },
                { dataKey: 'year' },
                { dataKey: 'credentials.created_at', transform: [this.isNumericDate] },
                { dataKey: 'credentials.updated_at', transform: [this.isNumericDate] },
            ],
        }
    },
    methods: {
        hasOpportunityUrl(key, value) {
            return this.hasUrlProperty(key, {
                t: value?.t,
                url: this.isMine ? `/mes-opportunites/${value?.k}` : `/toutes-les-opportunites/${value?.k}`,
            })
        },
    },
}
</script>

<template>
    <FiltersTemplate
        v-if="list?.meta"
        :meta="list.meta"
        :translation-name="list?.model?.translationKey"
        :filters="filters"
        @set-query="setQuery($event)"
        @reset-query="i3pService.resetQuery()"
    >
        <template #moreButtons>
            <GeojsonUrl v-if="list?.model" intentions-or-opportunities="intentions" />
            <ListActionsButtonsExport
                v-if="list?.model"
                :query="i3pService._query"
                :btn-style="{ variant: 'outlined', class: `ma-2` }"
                :request-name="list?.model?.endPoint"
                :translation-name="list?.model?.translationKey"
                :exportable="i3pService?.indexData?.meta.available_exports || []"
                show-disabled
            />
        </template>
        <template #filters>
            <BasicFiltersOverride
                ref="filters"
                :filters="filters"
                :translation-name="list?.model?.translationKey"
                @reset-pagination="i3pService.setPagination(1)"
                @load-data="i3pService.loadData()"
            />
            <!-- need to "setQuery" on @loadData if we want to listen to params in url (example : ?year=2025) -->
        </template>
    </FiltersTemplate>

    <list-table
        ref="table"
        class="px-2 my-2"
        :highlight-row="[i3pService.currentEntityK]"
        :loading="loadingList"
        :value-as-view-link="['id', 'name']"
        :disable-view="true"
        :permission-name="list?.model?.permissionName || ''"
        :translation-name="list?.model?.translationKey || ''"
        :sortable="list?.meta?.allowed_sorts || []"
        :default-url="baseUrl"
        :data="list?.data || []"
        :columns
        no-action
        :show-global-loader="true"
        @default-redirect-clicked="showEntity($event.k)"
        @update-sort="i3pService.setSort($event)"
        @load-data="i3pService.loadData()"
        @reset-pagination="i3pService.setPagination({ number: 1, size: list?.meta?.per_page })"
    >
        <!-- RESETPAGINATION WHEN SORT UPDATED -->
        <template #customColumn="{ item }">
            <IntentionsListButtons
                :item="item"
                :translation-name="list?.model?.translationKey"
                @view-route="showEntity(item.k)"
                @update-route="editEntity(item.k)"
                @delete-item="deleteEntity(item.k)"
            />
        </template>
    </list-table>
    <Pagination
        v-if="list?.meta"
        :list
        @load-data="i3pService.loadData()"
    />
</template>
